const ProjectList = [
{

  title: "Sleep Log",
  description: "I sought to identify a correlation between the outside temperature and the amount of sleep I achieved nightly. The result is a full CRUD web app logging key sleep stats directly from my Fitbit tracker. The accompanying temperature is pulled in from an open weather API.",
  technologies_used:"Express.js, Node.js",
  image_url: "http://res.cloudinary.com/dm6ofsjtd/image/upload/v1527553398/sleeplog.png",
  url: "https://sleep-weather-app.herokuapp.com/"
},
{
  title: "Slot Game" ,
  description: "This slot machine was created as my first project for General Assembly's WDI. Utilizing javascript logic as well as Jquery for DOM manipulation, I've created an interactive single player game interface.",
  technologies_used:"HTML5, CSS3, Javascript, Jquery",
  image_url:"http://res.cloudinary.com/dm6ofsjtd/image/upload/v1527315020/Screen_Shot_2018-05-26_at_2.08.16_AM.png",
  url: "http://dirty-brake.surge.sh/"
},
{
  title:"Crypton" ,
  description:"Seeking to solve the problem of scattered, and varied Crypto wallet platforms, we envisioned a centralized storage solution for cryptocurrency. The easy-to-navigate dashboard allows users to collect, organize, and view current news stories for their coins." ,
  technologies_used:"React.js, Express.js, Node.js, Bulma",
  image_url: "http://res.cloudinary.com/dm6ofsjtd/image/upload/v1527539178/Crypton2.png",
  url: ""
},
{
title:"Beer Calories",
  description:"Unsatisfied with the availability of beer nutrition calculator apps on the market, I created an API using exercise calorie expenditure data from my Fitbit and sourced beer nutrition facts from an open API. The result is an IOS calorie-counting app" ,
  technologies_used:"React Native, XCode, Ruby on Rails",
  image_url:"http://res.cloudinary.com/dm6ofsjtd/image/upload/v1530055903/Screen_Shot_2018-06-04_at_1.32.42_PM.png",
  url:""
},

]

export default ProjectList;



// WEBPACK FOOTER //
// ./src/components/ProjectList.js